import React from 'react';
import { Radio } from 'antd';
import { theme, Text } from '@pfmam/pfmam';
import { Box } from '../../styles/globalStyle';
import styled from 'styled-components';

const RadioItemsWrapper = styled.span`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-left: 15px;
`;

const Title = styled(Text)`
  font-weight: bold;
`;


const FundInvestmentTypeModal = ({
  onInvestmentTypeChange,
  fundDetails = [],
  selectedFundUniqueID
}) => {
  return (
    <Radio.Group
      size="large"
      onChange={({ target }) => onInvestmentTypeChange(target.value)}
      value={selectedFundUniqueID}
      style={{ width: '100%' }}
    >
      {fundDetails.map((type) => (
        <Radio.Button
          key={type.FundUniqueID}
          value={type.FundUniqueID}
        >
          <RadioItemsWrapper>
            <span>{type.FundShortName}</span>
          </RadioItemsWrapper>
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};

export default FundInvestmentTypeModal;
